import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-upload-file-dialog',
  templateUrl: './upload-file-dialog.component.html',
  styleUrls: ['./upload-file-dialog.component.scss'],
  standalone: false,
})
export class UploadFileDialogComponent {
  file: File;
  canUpload: boolean = false;
  fileName = '';
  constructor(
    public dialogRef: MatDialogRef<UploadFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
  UploadFile(event) {
    let f = event.target.files[0];
    if (f != undefined && f.name.endsWith('.xlsx')) {
      this.file = f;
      this.fileName = this.file.name;
      this.data = this.file;
      this.canUpload = true;
    } else {
      this.fileName = '';
      this.canUpload = false;
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
